<section
  class="min-h-[80vh] md:min-h-[70vh] bg-[url('/assets/images/Hero.jpg')] flex justify-center items-center bg-black/50 bg-cover bg-center bg-blend-multiply"
>
  <section
    class="w-full flex flex-col justify-center items-center gap-4 2xl:mt-20"
  >
    <h1
      class="text-white text-3xl md:text-4xl lg:text-5xl font-bold text-center max-w-3xl"
    >
      {{ selectedTabText }}
    </h1>
    <!-- Form -->
    <div class="w-[90%] lg:w-[70%] 2xl:w-[50%]">
      <out-hero-filter (tabChanged)="updateText($event)"></out-hero-filter>
    </div>
  </section>
</section>
